import React from 'react';

const DashboardHome = () => {
    return (
        <div>
            <h2 className="banner-title py-4 my-4">Welcome To Our Dashboard !</h2>
        </div>
    );
};

export default DashboardHome;